import './style/menu.scss';

import {AwesomeIcon, hasHover, Loader} from '@dvrd/dvr-controls';
import {IconName} from '@fortawesome/fontawesome-svg-core';
import classNames from 'classnames';
import React, {MouseEventHandler, useContext, useEffect, useRef, useState} from 'react';
import {getVehicleIcon} from '../../util/utils';
import {AppContext} from '../context/appContext';

interface Props {
    onClickLogout: MouseEventHandler;
    onClickDownload: MouseEventHandler;
    onClickVehicles: MouseEventHandler;
    loading: boolean;
}

export default function Menu(props: Props) {
    const {vehicle} = useContext(AppContext).vehicleContext;
    const {onClickLogout, onClickDownload, onClickVehicles, loading} = props;
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    function _onClick(onClick: MouseEventHandler) {
        return function (evt: React.MouseEvent) {
            setMenuOpen(false);
            onClick(evt);
        };
    }

    function onToggleMenu() {
        setMenuOpen(!menuOpen);
    }

    function clickListener() {
        if (!hasHover(menuRef.current)) setMenuOpen(false);
    }

    function renderMenu() {
        return (
            <div className={classNames('menu-container', menuOpen && 'open')}>
                {renderMenuItem(getVehicleIcon(vehicle), 'Voertuigen', onClickVehicles)}
                {renderMenuItem('download', 'Downloaden', onClickDownload)}
                {renderMenuItem('right-from-bracket', 'Uitloggen', onClickLogout)}
            </div>
        );
    }

    function renderMenuItem(icon: IconName, label: string, onClick: MouseEventHandler) {
        return (
            <div className='menu-item' onClick={_onClick(onClick)}>
                <AwesomeIcon name={icon} className='item-icon'/>
                <label className='item-label'>{label}</label>
            </div>
        );
    }

    useEffect(() => {
        if (menuOpen) window.setTimeout(() => {
            document.addEventListener('click', clickListener);
        });
        else document.removeEventListener('click', clickListener);

        return function () {
            document.removeEventListener('click', clickListener);
        };
    }, [menuOpen, clickListener]);

    return (
        <>
            <Loader active={loading}/>
            <div className='app-menu'>
                <div className='menu-icon-container' onClick={onToggleMenu}>
                    <AwesomeIcon name='bars' className='menu-icon'/>
                </div>
                {renderMenu()}
            </div>
        </>
    );
}

Menu.displayName = 'Menu';